function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const retryUntilOnline = async (db: any, retries: number, logger: any): Promise<any> => {
  try {
    return await db.info();
  } catch (e) {
    if (retries % 30 === 29) {
      logger.warn(`still waiting for db after ${retries} retries`, e);
    } else if (retries % 3 === 2) {
      logger.warn('still waiting for db');
    }
    await sleep(1000);
    return retryUntilOnline(db, retries + 1, logger);
  }
};

export const waitForDbToBeReady = async (PouchDB: any, url: string, auth: any, logger: any, fetch: any) => {
  logger.info(`waiting for db to be accessable at ${url}`);

  // todo: need to extract connection setup for dbs
  const ALLOW_SELF_SIGNED = {
    ajax: {
      rejectUnauthorized: false,
      requestCert: true,
      agent: false,
    },
  };

  // use pure node-fetch without cookies to workaround cloudflare cookie parse issue
  const USE_PURE_FETCH = {
      fetch: (urlInner: any, opts: any | undefined) => fetch(urlInner, { ...opts }),
    };

  const options = Object.assign({}, { auth }, ALLOW_SELF_SIGNED, USE_PURE_FETCH );

  const db = new PouchDB(url, options);
  const info = await retryUntilOnline(db, 0, logger);
  logger.info(`db is accessable ${JSON.stringify(info)}`);
};
